import React, {ReactNode} from "react";
import SubscriptionSettings from "../pages/SubscriptionSettings";
import Nps from "../pages/Nps";
import NpsThanks from "../pages/Nps/NpsThanks/NpsThanks";
import SubscriptionComment from "../pages/SubscriptionSettings/SubscriptionComment/SubscriptionComment";
import Subscribed from "../pages/SubscriptionSettings/Subscribed/Subscribed";
import SubscribeThanks from "../pages/SubscriptionSettings/SubscribeThanks/SubscribeThanks";
import Documentation from "../pages/Documentations/Documentation";

export interface IRoute {
    path: string;
    element: ReactNode;
}

export enum RouteNames {
    SUBSCRIPTION_SETTINGS = '/subscription/settings',
    SUBSCRIPTION_COMMENT = '/subscription/comment',
    SUBSCRIPTION_SUBSCRIBED = '/subscription/subscribed',
    SUBSCRIPTION_THANKS = '/subscription/thanks',
    NPS = '/nps',
    NPS_THANKS = '/nps/thanks',
    DOCUMENTATION = '/documentation'
}

export const routes: IRoute[] = [
    {path: RouteNames.SUBSCRIPTION_SETTINGS, element: <SubscriptionSettings />},
    {path: RouteNames.SUBSCRIPTION_COMMENT, element: <SubscriptionComment />},
    {path: RouteNames.SUBSCRIPTION_SUBSCRIBED, element: <Subscribed />},
    {path: RouteNames.SUBSCRIPTION_THANKS, element: <SubscribeThanks />},
    {path: RouteNames.NPS, element: <Nps/>},
    {path: RouteNames.NPS_THANKS, element: <NpsThanks/>},
    {path: RouteNames.DOCUMENTATION, element: <Documentation />}
]
